import { withNestedView } from '@/router/routerHelpers';
import { FEATURES } from '@/access/features';
import { PERMISSIONS } from '@/access/permissions';
const loadView = withNestedView('customObjects');

const viewPermissions = [
  PERMISSIONS.CUSTOM_OBJECTS,
  PERMISSIONS.MANAGE_CUSTOM_RECORDS,
  PERMISSIONS.MANAGE_CUSTOM_OBJECTS,
];

const manageRecordsPermissions = [
  PERMISSIONS.MANAGE_CUSTOM_RECORDS,
  PERMISSIONS.MANAGE_CUSTOM_OBJECTS,
];

const customObjectsRoutes = [
  {
    path: '/custom-objects',
    component: {
      render: (c) => c('router-view'),
    },
    meta: {
      feature: FEATURES.CUSTOM_OBJECTS,
      permissions: viewPermissions,
    },
    children: [
      {
        path: '',
        name: 'custom-objects',
        props: true,
        meta: {
          feature: FEATURES.CUSTOM_OBJECTS,
          permissions: viewPermissions,
        },
        component: loadView('CustomObjects'),
      },
      {
        path: ':id',
        name: 'custom-object-edit',
        props: true,
        meta: {
          feature: FEATURES.CUSTOM_OBJECTS,
          permissions: viewPermissions,
        },
        component: loadView('customRecords/CustomRecords'),
      },
      {
        path: ':id/standalone',
        name: 'custom-object-standalone',
        props: true,
        meta: {
          feature: FEATURES.CUSTOM_OBJECTS,
          permissions: viewPermissions,
        },
        component: loadView('customRecords/CustomRecords'),
      },
      {
        path: ':id/import',
        name: 'custom-object-import',
        props: true,
        meta: {
          feature: FEATURES.CUSTOM_OBJECTS,
          permissions: manageRecordsPermissions,
        },
        component: loadView('import/CustomObjectRecordImport'),
      },
      {
        path: ':id/standalone/import',
        name: 'custom-object-standalone-import',
        props: true,
        meta: {
          feature: FEATURES.CUSTOM_OBJECTS,
          permissions: manageRecordsPermissions,
        },
        component: loadView('import/CustomObjectRecordImport'),
      },
    ],
  },
];

export default customObjectsRoutes;
